import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function Rd2sReducer(state = initialState.rd2s, action: any) {
  switch (action.type) {
    case types.SAVE_RD2S_SUCCESS:
      return action.rd2s;
    default:
      return state;
  }
}
